import React from 'react';
import Breadcrumb from '../../components/breadcrumb';
import UQLabel from '../../components/label';
import UQSpacer from '../../components/spacer';
import UQCode from '../../components/code';
import UQDataGrid, { UQDataGridColumn } from '../../components/data-grid';
import { BREADCRUMB_ROOT } from '../../common/config';

const attributes = [
  { attribute: 'children', type: 'React.ReactNode', default: '', description: 'Label text or content.' },
  { attribute: 'size', type: "'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'", default: "'m'", description: 'Label size.' },
  { attribute: 'className', type: 'string', default: "''", description: 'Additional class names.' },
  { attribute: 'style', type: 'React.CSSProperties', default: 'undefined', description: 'Inline styles.' },
];

const attributeColumns: UQDataGridColumn<typeof attributes[0]>[] = [
  { columnId: 'attribute', renderHeaderCell: () => 'Attribute', renderCell: (item) => item.attribute },
  { columnId: 'type', renderHeaderCell: () => 'Type', renderCell: (item) => <code>{item.type}</code> },
  { columnId: 'default', renderHeaderCell: () => 'Default', renderCell: (item) => <code>{item.default}</code> },
  { columnId: 'description', renderHeaderCell: () => 'Description', renderCell: (item) => item.description },
];

const codeExample = `
import UQLabel from '@uniqconsulting/ui/components/label';

<UQLabel size="xxs">Extra Extra Small</UQLabel>
<UQLabel size="xs">Extra Small</UQLabel>
<UQLabel size="s">Small</UQLabel>
<UQLabel size="m">Medium</UQLabel>
<UQLabel size="l">Large</UQLabel>
<UQLabel size="xl">Extra Large</UQLabel>
<UQLabel size="xxl">Extra Extra Large</UQLabel>
`;

const LabelDemoPage = () => (
  <>
    <Breadcrumb crumbs={[BREADCRUMB_ROOT, 'Label']} />
    <h1>UQLabel Demo</h1>
    <UQSpacer size="m" />

    <h2>Description</h2>
    <p>
      <code>UQLabel</code> is a flexible label component that supports a range of sizes from <code>xxs</code> to <code>xxl</code>. Use it for captions, section titles, or anywhere you need consistent label styling.
    </p>
    <UQSpacer size="m" />

    <h2>Attributes</h2>
    <UQSpacer size="s" />
    <UQDataGrid
      items={attributes}
      columns={attributeColumns}
      sortable={false}
      selectionMode="none"
      rowLines
    />
    <UQSpacer size="m" />

    <h2>Examples</h2>
    <UQSpacer size="s" />
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'flex-start' }}>
      <UQLabel size="xxs">Extra Extra Small</UQLabel>
      <UQLabel size="xs">Extra Small</UQLabel>
      <UQLabel size="s">Small</UQLabel>
      <UQLabel size="m">Medium</UQLabel>
      <UQLabel size="l">Large</UQLabel>
      <UQLabel size="xl">Extra Large</UQLabel>
      <UQLabel size="xxl">Extra Extra Large</UQLabel>
    </div>
    <UQSpacer size="m" />

    <h2>Code Example</h2>
    <UQCode code={codeExample.trim()} enableCopy />
  </>
);

export default LabelDemoPage;